import { backendBridge } from '@klarna-web-sdk/backend-bridge'

export function klarnaIframeStorage(storageKey: string) {
  const getStorageObj = async () => {
    const storageObj = await backendBridge.call({
      method: 'getStorageItem',
      data: { key: storageKey },
    })
    return storageObj ? JSON.parse(storageObj) : {}
  }

  const StorageOps = {
    get: async (itemKey: string) => {
      const storageObj = await getStorageObj()

      const item = storageObj?.[itemKey]
      if (!item) return null

      const ttl = storageObj?.ttl

      if (ttl && ttl < Date.now()) {
        StorageOps.flush()
        return null
      }

      return item
    },
    set: async (itemKey: string, data: unknown) => {
      const storageObj = await getStorageObj()

      if (data === null) delete storageObj[itemKey]
      else storageObj[itemKey] = data

      return backendBridge.call({
        method: 'setStorageItem',
        data: {
          key: storageKey,
          data: JSON.stringify(storageObj),
        },
      })
    },
    remove: (itemKey: string) => {
      return StorageOps.set(itemKey, null)
    },
    flush: () => {
      return backendBridge.call({ method: 'removeStorageItem', data: { key: storageKey } })
    },
  }

  return StorageOps
}
